module.exports = __webpack_public_path__ + "img/new2-img1.b47eeac7.png";